<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">发布职位</span>
      </p>

      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <!--<div class="inforName">-->
        <!--<p class="inforNameTop">招聘类型</p>-->
        <!--<p class="inforNameTop type">-->
          <!--<van-dropdown-menu >-->
            <!--<van-dropdown-item v-model="values" :options="options" />-->
        <!--</van-dropdown-menu></p>-->
        <!--&lt;!&ndash;<p> <input class="inforNameInput" type="text" v-model="list.work_nature" placeholder="请填写" ></p>&ndash;&gt;-->

      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">招聘类型</p>
        <!--<p> <input class="inforNameInput" type="text" v-model="list.work_nature" placeholder="请填写" ></p>-->
        <p class="inforNameTop type" style="margin-left: -8px">
          <van-dropdown-menu  placeholder="请填写" >
          <van-dropdown-item v-model="value4" :options="option4" placeholder="请填写"/>
          <!--<van-dropdown-item v-model="value2" :options="option2" />-->
        </van-dropdown-menu>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位名称</p>
        <p> <input class="inforNameInput" type="text" v-model="list.name"  placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位类型</p>
        <p> <input class="inforNameInput" type="text" v-model="list.position_type" placeholder="请填写" ></p>
      </div>
      <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />

      <div class="inforWork">
        <div class="center">
          <div>
            <span @click="show=true" style="font-size: 14px;color:#DEDEDE " v-model="list.work_year">工作经验</span>

          </div>
          <div>
            <van-dropdown-menu placeholder="请填写" >
              <van-dropdown-item v-model="value1" :options="option1" placeholder="请填写"/>
              <!--<van-dropdown-item v-model="value2" :options="option2" />-->
            </van-dropdown-menu>
          </div>
          <!--<span>3年</span>-->

        </div>
        <!--<div class="inforWorkCenter">-->
        <div class="center inforWorkCenter">
          <span style="font-size: 14px;color:#DEDEDE">最低学历</span>
          <van-dropdown-menu placeholder="请填写" >
            <van-dropdown-item v-model="value2" :options="option2" placeholder="请填写"/>
            <!--<van-dropdown-item v-model="value2" :options="option2" />-->
          </van-dropdown-menu>
          <!--<span style="font-size: 14px;color:#DEDEDE"  v-model="list.edu">工作经验</span>-->
          <!--<span>3-5年</span>-->
        </div>
        <div class="center">
          <span style="font-size: 14px;color:#DEDEDE" v-model="list.salary">薪资范围</span>
          <!--<span>3-5年</span>-->
          <van-dropdown-menu placeholder="请填写" >
            <van-dropdown-item v-model="value3" :options="option3" placeholder="请填写"/>
            <!--<van-dropdown-item v-model="value2" :options="option2" />-->
          </van-dropdown-menu>
        </div>

      </div>
      <div class="inforName">
        <p class="inforNameTop">职位关键词</p>
        <!--<p> <input class="inforNameInput" type="text" v-model="list.keywords"  placeholder="请填写" ></p>-->
        <p  style="color: #323233;font-size: 15px" @click="toKeyWord">
          <span v-if="arr" v-for="(item ,index) in arr">&nbsp;&nbsp;{{item}}11</span>
          <span v-else="">&nbsp;&nbsp;请填写</span>
          <span v-else="">&nbsp;&nbsp;{{arr}}</span>
          <input v-if="arr" v-for="(item ,index) in arr" class="inforNameInput" type="text" :v-model="item" :value="item" placeholder="请填写" >
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位描述</p>
        <p >
          <textarea style="width: 100%;height: 5rem"  v-model="list.desc" placeholder="请填写"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位亮点</p>
        <p> <input class="inforNameInput" type="text" v-model="list.welfare"  placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所属部门</p>
        <p>
          <input class="inforNameInput" type="text" v-model="list.department" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">工作城市</p>
        <p> <input class="inforNameInput" type="text" v-model="list.city" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">详细地址</p>
        <p> <input class="inforNameInput" type="text" v-model="list.address" placeholder="请填写" ></p>
      </div>
      <div>

      </div>

    </div>
    <div class="inforName">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addReleasePositioner()">保存并发布</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        list:{
          work_nature:"",
          name:'',
          position_type:'',
          work_year:'',
          edu:"",
          salary:'',
          keywords:'',
          desc:'',
          welfare:'',
          department:'',
          city:'',
          address:''
        },
        show: false,
//        arr:["电商","体育"],
        arr:[],
        actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
        value: 0,
        values: 0,
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        option: [
          { text: '全部商品', value: 0 },
          { text: '新款商品', value: 1 },
          { text: '活动商品', value: 2 },
        ],
        options: [
          { text: '默认排序', value: 0 },
          { text: '好评排序', value: 1 },
          { text: '销量排序', value: 2 },
        ],
        option1: [
          { text: '请选择', value: 0 },
          { text: '不限', value: 1 },
          { text: '一年以下', value: 2 },
          { text: '1-3年', value: 3 },
          { text: '3-5年', value: 4},
          { text: '5-10年', value: 5 },
          { text: '10年以上', value: 6 },
        ],
        option2: [
          { text: '请选择', value: 0, },
          { text: '不限', value: 1 },
          { text: '大专', value: 2 },
          { text: '本科', value: 3 },
          { text: '硕士', value: 4 },
          { text: '博士', value: 5 },
        ],
        option3: [
          { text: '请选择', value: 0 },
          { text: '1-2K', value: 1 },
          { text: '2-4K', value: 2 },
          { text: '4-6K', value: 3 },
          { text: '6-8K', value: 4 },
          { text: '8-10K', value: 5 },
          { text: '10-15K', value: 6 },
          { text: '15-20K', value: 7 },
          { text: '20-25K', value: 8 },
          { text: '25-35K', value: 9 },
          { text: '35-50K', value: 10 },
          { text: '50-70K', value: 11 },
          { text: '70-100K', value: 12 },
          { text: '100K以上', value: 13 },
        ],
        option4: [
          { text: '请选择', value: 0, },
          { text: '全职', value: 1, },
          { text: '兼职', value: 1 },
          { text: '实习', value: 2 },
        ],
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
        localStorage.removeItem("keyWord")
      },
      toKeyWord(){
        this.$router.push("/addkeyWord")
      },
//      getArr(){
//        this.keywordList=JSON.parse(localStorage.getItem('keyWord'))
//      },
      getWord(){
        var list=JSON.parse(localStorage.getItem("keyWord"))
        if (list) {
           for(var a=0 ;a<list.length;a++){
            console.log(list[a])
            this.arr.push(list[a].name)
//           this.arr=this.msg+list[a].name+","
          }
        }

//        for (var a in list)

        console.log(this.arr)
      },
      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false;
//        Toast(item.name);
        this.msg=item.name
        this.$toast(item.name)
      },
      addReleasePositioner(){
       if (localStorage.getItem("companyId")){
             this.$api.addReleasePosition({
               "data[work_nature]": this.value4,
               "data[name]": this.list.name,
               "data[position_type]": this.list.position_type,
               "data[work_year]": this.value1,
               "data[edu]": this.value2,
               "data[salary]": this.value3,
//               "data[keywords]":this.list.keywords,
               "data[keywords]":this.arr,
               "data[desc]":this.list.desc,
               "data[welfare]":this.list.welfare,
               "data[department]":this.list.department,
               "data[city]":this.list.city,
               "data[address]":this.list.address,
//          "jobid":this.$route.params.id
               "data[company_id]":localStorage.getItem("companyId"),
               "data[user_id]":localStorage.getItem("userid")
             }).then(res=>{
               if(res.status==200){
                 this.$router.push("/comPosition")
                 localStorage.removeItem("keyWord")
               }

             }).catch(err=>{
             })
           }else {
             this.$toast("您还没有公司！")
           }

      },
    },
    mounted(){
      this.getWord()
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 5rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  .inforWork{
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: solid 1px #DEDEDE;
    padding: 20px 0;
  }
  .inforWork span{
    display: block;

  }
  .inforWork div{
    text-align: center;
    /*padding: 8px 10px;*/
    /*margin: 8px 10px;*/
  }
  .inforWorkCenter{
    width: 35%;
    border-left: solid 1px #DEDEDE;
    border-right: solid 1px #DEDEDE;
  }
 /deep/ .van-dropdown-menu__bar{
    box-shadow: 0 2px 12px rgba(0,0,0,0)
  }
  .center{
  /*width: 30%;*/
  }
  /deep/ .type .van-dropdown-menu__item{
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
  }
  input::-webkit-input-placeholder{
    color:#323233;
    /*font-size: 14px;*/
  }
  input{
    font-size: 14px;
  }
  /deep/.van-ellipsis{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/releasePosition.vue